module.exports = __webpack_public_path__ + "static/img/blg-bg-im.6b7260a1.png";